import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Paper, BackButton, Button, CreditHistory } from 'components';
import { headerLeftTitle, headerLeftSubTitle, headerLeftId } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var BorrowerCkr = function BorrowerCkr(_ref) {
  var _location$state, _match$params;

  var history = _ref.history,
      location = _ref.location,
      match = _ref.match;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      borrower = _ref2.borrower;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      borrowerIdNumber = _ref3.borrowerIdNumber;

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, null), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u0415\u0413\u041D: ", borrowerIdNumber), ___EmotionJSX("h6", {
    css: headerLeftSubTitle
  }, "\u0411\u0440\u043E\u0439 \u043A\u0440\u0435\u0434\u0438\u0442\u0438: ".concat(borrower === null || borrower === void 0 ? void 0 : borrower.credits_count, " - \u0410\u043A\u0442\u0438\u0432\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438: ").concat(borrower === null || borrower === void 0 ? void 0 : borrower.active_credits_count)), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, borrower === null || borrower === void 0 ? void 0 : borrower.first_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.middle_name, " ", borrower === null || borrower === void 0 ? void 0 : borrower.last_name)))), ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, null, ___EmotionJSX(Paper, {
    header: " \u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0438 \u0430\u043A\u0442\u0443\u0430\u043B\u043D\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0438"
  }, ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, null, ___EmotionJSX(CreditHistory, {
    idNumber: borrowerIdNumber
  })), ___EmotionJSX(Col, {
    displayFlex: true,
    justify: "flex-end"
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return history.push('/borrowers');
    }
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438")))))));
};

BorrowerCkr.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object
};
export default BorrowerCkr;